"use client";

import { useServiceData } from "../../hooks/useServiceData";
import React from "react";
import styles from "./AIMLServicesCardSection.module.css";
import ServiceCard from "../../components/ServiceCard";
import aiMlServicesData from "../../data/ai-ml";

export default function AIMLServicesCardSection() {
  const { data: backendPageData } = useServiceData();
  const services = backendPageData?.services;
  const displayData = services?.items || aiMlServicesData;

  return (
    <section className={styles.section}>
      <div className="container">
        <div className="text-center mb-4" data-reveal="slide-up">
          <div className={styles.eyebrow}>{services?.title || "AI & ML"}</div>
          <h2 className={styles.title}>{services?.subtitle || "AI & ML Services"}</h2>
        </div>

        <div className="row g-3 g-md-4" data-reveal="stagger-up">
          {displayData.map((card) => (
            <div className="col-12 col-md-6 col-lg-4" key={card.title}>
              <ServiceCard
                title={card.title}
                description={card.description}
                bullets={card.bullets} tags={card.tags}
                minHeight={card.minHeight}
                accent={card.accent}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
